<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/oJS979/tc-custom/9781488047091.jpg?1718106505060" alt="This image is the cover for the book Rescued by the Viking"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Rescued by the Viking
      </h1>
      <p class="bookDescription body article font2">
        <b>A woman enlists her adversary’s help to save her brother from captivity in this enemies to lovers medieval romance.</b><br/><br/>A brave Viking . . . is her sworn enemy!<br/><br/>When Norman Lady Gisela strays into hostile Saxon territory, she doesn’t expect to be rescued by a mysterious Viking. She has no delusions handsome Ragnar Svendsen would be interested in her with her war wounds, but she must make a deal with him to rescue her brother from his Saxon captors. Their journey results in unexpected passion, but surely there can be no future for Gisela with her enemy?<br/><br/>“Fuller captures the aura of the Middle Ages as she brings an emotionally scarred warrior and a strong-willed woman together in a captive/captor romance.” —<i>RT Book Reviews</i> on <i>The Warrior’s Damsel in Distress</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Meriel Fuller
      </h2>
      
      <p class="authorDescription body article">Meriel Fuller spent her early childhood with her nose buried in books. After school, she would walk to the town library where her mother was head librarian and happily read her way through the historical romance section. Although Meriel had always written as a hobby, it was only when her youngest child was a toddler that she decided to write a historical romance of her own and was thrilled when Harlequin told her that her manuscript would be published: a real dream come true!</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?dd28a9b4